import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../../Base.constants';
import SortableElementsList from '../../../components/SortableElementsList';
import AnnouncementsWidget from '../../../components/widgets/Annoucements';
import CRQuickFilters from '../../../components/widgets/CRQuickFilters';
import CSQuickLinks from '../../../components/widgets/CSQuickLinks';
import MorningCommentWidget from '../../../components/widgets/MorningComment';
import RecentlyViewed from '../../../components/widgets/RecentlyViewed';
import RecentRecChangesWidget from '../../../components/widgets/RecentRecChanges';
import TopReadsWidget from '../../../components/widgets/TopReads';
import { useFeedFilters } from '../../../hooks/common';
import { GLOBAL_ONLY_WIDGETS, WIDGET_ID } from '../Feed.constants';
import styles from './FeedRightContainer.module.scss';

const cx = classNames.bind(styles);

interface FeedRightContainerProps {
  isArticlePreviewOpen: boolean;
  rightSideWidgets: WIDGET_ID[];
  isContainerActive: boolean;
}

const FeedRightContainer = ({
  isArticlePreviewOpen,
  rightSideWidgets,
  isContainerActive,
}: FeedRightContainerProps): ReactElement => {
  const { pathname } = useLocation();
  const { filters } = useFeedFilters();
  const globalFeed = pathname === ROUTES.globalFeed;

  const filteredRightSideWidgets = !globalFeed
    ? rightSideWidgets.filter((item) => !GLOBAL_ONLY_WIDGETS.includes(item))
    : rightSideWidgets;

  const renderWidget = (widgetId: WIDGET_ID, isDragged?: boolean) => {
    switch (widgetId) {
      case WIDGET_ID.ANNOUNCEMENTS:
        return <AnnouncementsWidget showDragButton isDragged={isDragged} />;
      case WIDGET_ID.MORNING_COMMENT:
        return <MorningCommentWidget showDragButton isDragged={isDragged} />;
      case WIDGET_ID.TOP_READS:
        return <TopReadsWidget showDragButton isDragged={isDragged} />;
      case WIDGET_ID.RECENTLY_REC_CHANGES:
        return (
          <RecentRecChangesWidget showDragButton isDragged={isDragged} filters={filters} globalFeed={globalFeed} />
        );
      case WIDGET_ID.RECENTLY_VIEWED:
        return <RecentlyViewed showDragButton isDragged={isDragged} />;
      case WIDGET_ID.CR_QUICK_FILTERS:
        return <CRQuickFilters showDragButton isDragged={isDragged} />;
      case WIDGET_ID.CS_QUICK_LINKS:
        return <CSQuickLinks showDragButton isDragged={isDragged} />;
      default: {
        return null;
      }
    }
  };

  return (
    <div data-testid="feed-right-container" className={cx('body', { 'article-preview-open': isArticlePreviewOpen })}>
      <div data-testid="widgets-wrapper" className={cx('widgets-wrapper', { 'is-highlighted': isContainerActive })}>
        <SortableElementsList renderElement={renderWidget} items={filteredRightSideWidgets} id="rightSideWidgets" />
      </div>
    </div>
  );
};

export default FeedRightContainer;
